import * as yup from 'yup';
import { createCompanyEmployeeFormFields } from '../../fields/formFields/createCompanyEmployee';
import { emailSchema } from '../common/emailSchema';
import { phoneSchema } from '../common/phoneSchema';

export const createCompanyEmployeeSchema = yup.object({
  [createCompanyEmployeeFormFields.company_group]: yup.string().required('Company Group is required').trim(),
  [createCompanyEmployeeFormFields.full_name_en]: yup
    .string()
    .max(150, 'Full Name (EN) must be at most 150 characters')
    .required('Full Name (EN) is required')
    .trim(),
  [createCompanyEmployeeFormFields.full_name_ar]: yup
    .string()
    .max(150, 'Full Name (AR) must be at most 150 characters')
    .required('Full Name (AR) is required')
    .trim(),
  [createCompanyEmployeeFormFields.email]: emailSchema,
  [createCompanyEmployeeFormFields.phone_number]: phoneSchema,
  [createCompanyEmployeeFormFields.national_id]: yup.string().required('National ID is required').trim(),
  [createCompanyEmployeeFormFields.national_id_expiry]: yup.string().required('National ID Expiry is required').trim(),
  [createCompanyEmployeeFormFields.id_issue_date]: yup.string().required('ID issue date is required').trim(),
  [createCompanyEmployeeFormFields.gender]: yup.string().required('Gender is required').trim(),
  [createCompanyEmployeeFormFields.address]: yup
    .string()
    .max(500, 'Address must be at most 500 characters')
    .required('Address is required')
    .trim(),
  [createCompanyEmployeeFormFields.date_of_birth]: yup.string().required('Date of Birth is required').trim(),
  [createCompanyEmployeeFormFields.company_employee_marital_status]: yup
    .string()
    .required('Marital Status is required')
    .trim(),
  [createCompanyEmployeeFormFields.job_title]: yup
    .string()
    .max(150, 'Job Title must be at most 150 characters')
    .required('Job Title is required')
    .trim(),
  [createCompanyEmployeeFormFields.department]: yup.string().required('Department is required').trim(),
  [createCompanyEmployeeFormFields.joining_date]: yup.string().required('Joining Date is required').trim(),
  [createCompanyEmployeeFormFields.salary]: yup
    .number()
    .positive('Salary must be positive')
    .required('Salary is required'),
  [createCompanyEmployeeFormFields.employee_contribution_amount]: yup
    .number()
    .min(0, 'Employee Contribution Amount must be 0 or greater')
    .required('Employee Contribution Amount is required'),
  [createCompanyEmployeeFormFields.company_employee_status_id]: yup
    .number()
    .positive('Employee Status is required')
    .required('Employee Status is required'),
  [createCompanyEmployeeFormFields.type]: yup
    .number()
    .transform((value, originalValue) => (originalValue === '' || originalValue === null ? undefined : value))
    .typeError('Type is required')
    .required('Type is required'),
  [createCompanyEmployeeFormFields.family_name_en]: yup.string().trim().required('Family name (EN) is required'),
  [createCompanyEmployeeFormFields.family_name_ar]: yup.string().trim().required('Family name (AR) is required'),
  [createCompanyEmployeeFormFields.first_name_ar]: yup.string().trim().required('First name (AR) is required'),
  [createCompanyEmployeeFormFields.first_name_en]: yup.string().trim().required('First name (EN) is required'),
  [createCompanyEmployeeFormFields.father_name_ar]: yup.string().trim().required('Father name (AR) is required'),
  [createCompanyEmployeeFormFields.assurance_level]: yup.string().trim().required('Assurance level is required'),
  [createCompanyEmployeeFormFields.father_name_en]: yup.string().trim().required('Father name (EN) is required'),
  [createCompanyEmployeeFormFields.grand_father_name_ar]: yup
    .string()
    .trim()
    .required('Grand father name (AR) is required'),
  [createCompanyEmployeeFormFields.grand_father_name_en]: yup
    .string()
    .trim()
    .required('Grand father name (EN) is required'),
  [createCompanyEmployeeFormFields.nationality_ar]: yup.string().trim().required('Nationality (AR) is required'),
  [createCompanyEmployeeFormFields.nationality_en]: yup.string().trim().required('Nationality (EN) is required'),
  [createCompanyEmployeeFormFields.issue_location_ar]: yup.string().trim().required('Issue location (AR) is required'),
  [createCompanyEmployeeFormFields.issue_location_en]: yup.string().trim().required('Issue location (EN) is required'),
  [createCompanyEmployeeFormFields.language]: yup.string().trim().required('Language is required'),
  [createCompanyEmployeeFormFields.iqama_expiry_date]: yup
    .string()
    .required('Iqama expiry date is required')
    .test('is-date', 'Iqama expiry date must be a valid ISO 8601 date string', (value) => {
      if (!value) return false;
      if (typeof value !== 'string') return false;
      // Expecting YYYY-MM-DD format
      const isoDateRegex = /^\d{4}-\d{2}-\d{2}$/;
      if (!isoDateRegex.test(value)) {
        return false;
      }
      const date = new Date(value);
      return !Number.isNaN(date.getTime());
    }),
  [createCompanyEmployeeFormFields.education_level]: yup.string().trim().required('Education level is required'),
  [createCompanyEmployeeFormFields.country]: yup.string().trim().required('Country is required'),
  [createCompanyEmployeeFormFields.five_years_financial_sector]: yup.string().nullable(),
  [createCompanyEmployeeFormFields.five_years_financial_sector_description]: yup.string().nullable(),
  [createCompanyEmployeeFormFields.board_directors_member]: yup.string().nullable(),
  [createCompanyEmployeeFormFields.board_directors_member_description]: yup.string().nullable(),
  [createCompanyEmployeeFormFields.individual_with_high_profile_political_role]: yup.string().nullable(),
  [createCompanyEmployeeFormFields.individual_with_high_profile_political_role_description]: yup.string().nullable(),
  [createCompanyEmployeeFormFields.not_beneficial_owner]: yup.string().nullable(),
  [createCompanyEmployeeFormFields.not_beneficial_owner_description]: yup.string().nullable(),
});
